// Product Messages Variant Handler
// Shows/hides product messages based on variant metafields

document.addEventListener('DOMContentLoaded', function () {
  // Find all message wrapper divs (the parent divs we added in Liquid)
  const messageWrappers = document.querySelectorAll(
    '.product__stock-status > div:has(.product__message)'
  );

  // Only proceed if there are message wrappers
  if (messageWrappers.length === 0) {
    return;
  }

  // Function to update message visibility
  function updateMessageVisibility(variant) {
    if (!variant) {
      return;
    }

    // Iterate through each message wrapper
    messageWrappers.forEach((wrapper) => {
      const messageContainer = wrapper.querySelector('.product__message');

      if (!messageContainer) {
        return;
      }

      // Determine message type from the class name
      let messageType = null;

      if (messageContainer.classList.contains('product__message--bulky_goods')) {
        messageType = 'bulky_goods';
      } else if (
        messageContainer.classList.contains('product__message--dangerous_goods')
      ) {
        messageType = 'dangerous_goods';
      } else if (messageContainer.classList.contains('product__message--order_in')) {
        messageType = 'order_in';
      } else if (messageContainer.classList.contains('product__message--online_only')) {
        messageType = 'online_only';
      } else if (messageContainer.classList.contains('product__message--pre_order')) {
        messageType = 'pre_order';
      }

      // Check if variant has the corresponding metafield
      let shouldShow = false;

      switch (messageType) {
        case 'bulky_goods':
          shouldShow = variant.metafields?.custom?.exo_bulky_goods === true;
          break;
        case 'dangerous_goods':
          shouldShow = variant.metafields?.custom?.exo_dangerous_goods === true;
          break;
        case 'order_in':
          shouldShow = variant.metafields?.custom?.exo_order_in_xtra_field === true;
          break;
        case 'online_only':
          shouldShow = variant.metafields?.custom?.exo_online_only === true;
          break;
        case 'pre_order':
          shouldShow = variant.metafields?.custom?.pre_order === true;
          break;
      }

      // Show or hide the wrapper div
      wrapper.style.display = shouldShow ? '' : 'none';
    });
  }

  // Function to update cart properties based on variant metafields
  function updateCartProperties(variant) {
    if (!variant) {
      return;
    }

    // Find all property inputs that need to be updated based on variant
    const bulkyGoodsInput = document.querySelector('input[name="properties[_exo_bulky_goods]"]');
    const onlineOnlyInput = document.querySelector('input[name="properties[_exo_online_only]"]');
    const preOrderInput = document.querySelector('input[name="properties[_pre_order]"]');

    // Update bulky goods property
    if (bulkyGoodsInput) {
      if (variant.metafields?.custom?.exo_bulky_goods === true) {
        bulkyGoodsInput.value = 'true';
        bulkyGoodsInput.disabled = false;
      } else {
        // Disable the input so it doesn't get submitted to cart
        bulkyGoodsInput.disabled = true;
      }
    }

    // Update online only property
    if (onlineOnlyInput) {
      if (variant.metafields?.custom?.exo_online_only === true) {
        onlineOnlyInput.value = 'true';
        onlineOnlyInput.disabled = false;
      } else {
        // Disable the input so it doesn't get submitted to cart
        onlineOnlyInput.disabled = true;
      }
    }

    // Update pre order property
    if (preOrderInput) {
      if (variant.metafields?.custom?.pre_order === true) {
        preOrderInput.value = 'true';
        preOrderInput.disabled = false;
      } else {
        // Disable the input so it doesn't get submitted to cart
        preOrderInput.disabled = true;
      }
    }
  }

  // Listen for variant changes
  document.addEventListener('theme:variant:change', function (event) {
    const { variant } = event.detail;
    updateMessageVisibility(variant);
    updateCartProperties(variant);
  });

  // Update properties and message visibility on initial page load for the current variant
  // Use cached variant metafields from helper instead of parsing again
  const variantMetafields = window.variantMetafieldsHelper?.getMetafields();
  if (variantMetafields) {
    const currentVariantId = document.querySelector('input[name="id"]')?.value;

    if (currentVariantId && variantMetafields[currentVariantId]) {
      const currentVariant = {
        metafields: {
          custom: variantMetafields[currentVariantId]
        }
      };
      updateMessageVisibility(currentVariant);
      updateCartProperties(currentVariant);
    }
  }
});